import { render, staticRenderFns } from "./SemeiaNetwork.vue?vue&type=template&id=65f44e7e&scoped=true"
import script from "./SemeiaNetwork.vue?vue&type=script&lang=js"
export * from "./SemeiaNetwork.vue?vue&type=script&lang=js"
import style0 from "./SemeiaNetwork.vue?vue&type=style&index=0&id=65f44e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f44e7e",
  null
  
)

export default component.exports